import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpClient, HttpRequest, HttpHeaders} from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc';
import {throwError, BehaviorSubject} from 'rxjs';
import {environment} from 'src/environments/environment';
import {mergeMap, catchError, tap, switchMap, filter, take} from 'rxjs/operators';
import {SarService} from './sar.service';
import {CustomsValidators} from '../../validators/custom.validators';
import { Router } from '@angular/router';
import { UnauthBackendComponent } from '../unauth-backend/unauth-backend.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);


  constructor(
    private oauthService: OAuthService,
    private http: HttpClient,
    private dataApiSar: SarService,
    private router: Router,
    public   dialog :  MatDialog) {
  }

  intercept(req, next) {

    let tokenizedReq;
    String(window.location.pathname);
    if (sessionStorage.Token === undefined) {
      tokenizedReq = req.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          'Cross-Origin-Opener-Policy': 'same-origin',
          'Cross-Origin-Embedder-Policy': 'require-corp',
          'Cross-Origin-Resource-Policy': 'same-origin',
          Pragma: 'no-cache',
          Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
          'If-Modified-Since': '0',
          Authorization: `Bearer ${this.oauthService.getAccessToken()}`,
          AzureTokenAd: `${this.oauthService.getIdToken()}`,
          'client_id': "", //environment.mulesoft_clientid,
          'client_secret': "" //environment.mulesoft_secret
        }
      });
    } else {
      if (!req.headers.get('Authorization')) {
        tokenizedReq = req.clone({
          setHeaders: {
            'Cache-Control': 'no-cache',
            'Cross-Origin-Opener-Policy': 'same-origin',
            'Cross-Origin-Embedder-Policy': 'require-corp',
            'Cross-Origin-Resource-Policy': 'same-origin',
            Pragma: 'no-cache',
            Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
            'If-Modified-Since': '0',
            Authorization: `Bearer ${sessionStorage.getItem('Token')}`,
            AzureTokenAd: `${this.oauthService.getIdToken()}`,
            'client_id': "", //environment.mulesoft_clientid,
            'client_secret': "" //environment.mulesoft_secret

          }
        });
      }
    }
    return next.handle(tokenizedReq).pipe(catchError(err => {
      if (err.status === 401) {
        // tslint:disable-next-line:triple-equals
        if(err.error.error =="Invalid Client"){
          if(!UnauthBackendComponent.yaMeVi) {
            const dialogRef = this.dialog.open(UnauthBackendComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
              data: {
              },
            });
            dialogRef.afterClosed().subscribe(() => {
              UnauthBackendComponent.yaMeVi = false;
            });
            return throwError(err); //
          }
        }
        if(err.error.error == 'Invalid token.') {
          sessionStorage.clear();
          this.oauthService.logOut();
          location.reload();
        }
        if (err.error.message == 'HTTP 401 Unauthorized' || err.error instanceof Blob) {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            const item = {
              SARToken: sessionStorage.Token,
              RefreshToken: sessionStorage.RefreshToken,
            };
            const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
            const urlBuilder = `${environment.bffBaseUrl}/sar/auth/refresh`;
            return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, item, {headers: headersObject}).pipe(mergeMap(
              (data: any) => {
                if (data !== undefined || data != null) {
                  sessionStorage.setItem('Token', data.SARToken);
                  sessionStorage.setItem('RefreshToken', data.RefreshToken);
                  this.isRefreshing = false;
                  this.refreshTokenSubject.next(data.SARToken);
                  return next.handle(this.addToken(req, data.SARToken));
                } else {
                  // Logout from account
                  this.dataApiSar.Logout().subscribe(() => {
                    sessionStorage.clear();
                    this.oauthService.logOut();
                  }, () => {
                    sessionStorage.clear();
                    this.oauthService.logOut();
                  });
                }
              }
            )) : throwError(CustomsValidators.msgNotValidUrl);
          } else {
            return this.refreshTokenSubject.pipe(
              filter(token => token != null),
              take(1),
              switchMap(jwt => {
                return next.handle(this.addToken(req, sessionStorage.Token));
              }));
          }
        }
      }
      return throwError(err);
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        'Cross-Origin-Opener-Policy': 'same-origin',
        'Cross-Origin-Embedder-Policy': 'require-corp',
        'Cross-Origin-Resource-Policy': 'same-origin',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        'If-Modified-Since': '0',
        Authorization: `Bearer ${token}`,
        AzureTokenAd: `${this.oauthService.getIdToken()}`,
        'client_id': "", //environment.mulesoft_clientid,
        'client_secret': "" //environment.mulesoft_secret
      }
    });
  }
}
